var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionnaireCount = function SvgQuestionnaireCount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "questionnaireCount_svg__a",
    d: "M12.96 12.49A3.045 3.045 0 0 0 16 9.45V3.04A3.044 3.044 0 0 0 12.96 0H3.04A3.043 3.043 0 0 0 0 3.04v10.61c0 .547.323 1.037.83 1.24.165.069.34.11.52.11.355 0 .702-.146.95-.4l2.11-2.11z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "questionnaireCount_svg__b",
    width: 16,
    height: 15,
    x: 0,
    y: 0,
    fill: "#fff",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#questionnaireCount_svg__a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8FF",
    d: "M6 0h20a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 9)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#questionnaireCount_svg__a",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeDasharray: "0,0",
    strokeWidth: 3.333,
    mask: "url(#questionnaireCount_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M4.438 3.53h6.235a.882.882 0 0 1 0 1.764H4.438a.882.882 0 0 1 0-1.765M4.438 7.059h1.79a.882.882 0 0 1 0 1.765h-1.79a.882.882 0 1 1 0-1.765"
  })))));
};
export default SvgQuestionnaireCount;